import React from 'react';

function Section({section, reverse}) {
    const visual = (
        <div className="col-12 col-md-5 mb-4 mb-md-0">
            <div className="info-visual">
                <div className="info-visual-circle">
                    <img src={section.icon} alt="" className="info-visual-icon"/>
                </div>
            </div>
        </div>
    );

    const content = (
        <div className="col-12 col-md-7 info-content">
            <span className="info-eyebrow">Foot Health Information</span>
            <h2>{section.title}</h2>
            {section.subtitle && <p className="info-subtitle">{section.subtitle}</p>}

            {section.items.map((item) => (
                <div className="info-item" key={item.name}>
                    <p className="info-item-name">
                        {item.name}
                        {item.subtitle && <span className="info-item-subtitle"> ({item.subtitle})</span>}
                    </p>
                    <p className="info-item-description">{item.description}</p>
                    {item.note && <p className="info-item-note">{item.note}</p>}
                </div>
            ))}

            <a
                className="btn btn-warning rounded-pill text-white fw-bold border-0 px-4 py-2 mt-3"
                href="/appointment"
            >
                Book an Appointment
            </a>
        </div>
    );

    return (
        <div id={section.id} className={`info-section ${reverse ? 'shaded' : ''}`}>
            <div className="container">
                <div className="row align-items-center">
                    {reverse ? (
                        <>
                            {content}
                            {visual}
                        </>
                    ) : (
                        <>
                            {visual}
                            {content}
                        </>
                    )}
                </div>
            </div>
        </div>
    );
}

export default Section;
